import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const KOTService = {
  // Define your API functions here
  create: async (data) => {
    const response = await apiService.post("/orderprintinglog/ongoing-tables-orders", data);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/orderprintinglog/ongoing-tables-orders/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
  getList: async () => {
    const response = await apiService.get("/orderprintinglog/ongoing-tables-orders");
    return response.data;
  },
  getCustomerDetail: async (id) => {
    const response = await apiService.get(`/orderprintinglog/ongoing-tables-orders/${id}`);
    return response.data;
  },
  getCustomerBooking: async (id) => {
    const response = await apiService.get(`/customers/${id}/bookings`);
    return response.data;
  },

  guestUserList: async () => {
    const response = await apiService.get("/guestusers");
    return response.data;
  },
  getGuestDetail: async (id) => {
    const response = await apiService.get(
      `/orderprintinglog/ongoing-tables-orders/guest/withorderdetail/${id}`
    );
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/orderprintinglog/ongoing-tables-orders/${id}`);
    return response.data;
  },
};

export default KOTService;
